<template>
  <div
    id="ticket-update-footer-container"
    class="w-full pl-5"
  >
    <!-- Aguardando cliente -->
    <div
      id="ticket-footer-customer"
      v-if="lastStatus.status === 'awaiting_customer'"
      class="w-full relative pl-10 sm:pl-16 pb-4"
    >

      <div
        id="status-icon-customer"
        class="absolute -left-7.2 -top-3 p-2.5 text-center align-middle rounded-full bg-white"
      >
        <svg
          xmlns="http://www.w3.org/2000/svg"
          class="h-10 w-10 rounded-full p-1/2 text-center align-middle text-white bg-orange-organization"
          viewBox="0 0 20 20"
          fill="currentColor"
        >
          <path
            fill-rule="evenodd"
            d="M18 10a8 8 0 11-16 0 8 8 0 0116 0zm-7 4a1 1 0 11-2 0 1 1 0 012 0zm-1-9a1 1 0 00-1 1v4a1 1 0 102 0V6a1 1 0 00-1-1z"
            clip-rule="evenodd"
          />
        </svg>
      </div>

      <div
        id="ticket-footer-body-customer"
        class="w-full flex flex-col justify-start items-start text-gray-800"
      >
        <div class="w-full flex flex-row  justify-start items-center">
          <svg
            xmlns="http://www.w3.org/2000/svg"
            class="h-4 w-4 text-gray-500 -ml-px relative -top-px"
            fill="none"
            viewBox="0 0 24 24"
            stroke="currentColor"
          >
            <path
              stroke-linecap="round"
              stroke-linejoin="round"
              stroke-width="2"
              d="M8 7V3m8 4V3m-9 8h10M5 21h14a2 2 0 002-2V7a2 2 0 00-2-2H5a2 2 0 00-2 2v12a2 2 0 002 2z"
            />
          </svg>
          <span
            class="font-medium ml-2"
          >
            {{ lastStatus.date | formatDate }}
          </span>
        </div>
        <div class="w-full flex flex-row justify-start items-center relative">
          <div class="w-2.5 h-2.5 rounded-full relative -top-px bg-orange-organization" />
          <div class="ml-2.5 text-lg font-medium text-orange-organization">
            {{ lastStatus.title }}
          </div>
        </div>
        <div class="mt-2.5">
          {{ lastStatus.body }}
        </div>
      </div>

    </div>

    <!-- Em atendimento -->
    <div
      id="ticket-footer-organization"
      v-if="lastStatus.status === 'awaiting_mobly'"
      class="w-full relative pl-10 sm:pl-16 pb-4"
    >

      <div
        id="status-icon-organization"
        class="absolute -left-7.2 -top-3 p-2.5 text-center align-middle rounded-full bg-white"
      >
        <svg
          xmlns="http://www.w3.org/2000/svg"
          class="h-10 w-10 rounded-full p-1/2 text-center align-middle text-white bg-blue-organization"
          viewBox="0 0 20 20"
          fill="currentColor"
        >
          <path
            fill-rule="evenodd"
            d="M10 18a8 8 0 100-16 8 8 0 000 16zm1-12a1 1 0 10-2 0v4a1 1 0 00.293.707l2.828 2.829a1 1 0 101.415-1.415L11 9.586V6z" clip-rule="evenodd"
          />
        </svg>
      </div>

      <div
        id="ticket-footer-body-organization"
        class="w-full flex flex-col justify-start items-start text-gray-800"
      >
        <div class="w-full flex flex-row  justify-start items-center">
          <svg
            xmlns="http://www.w3.org/2000/svg"
            class="h-4 w-4 text-gray-500 -ml-px relative -top-px"
            fill="none"
            viewBox="0 0 24 24"
            stroke="currentColor"
          >
            <path
              stroke-linecap="round"
              stroke-linejoin="round"
              stroke-width="2"
              d="M8 7V3m8 4V3m-9 8h10M5 21h14a2 2 0 002-2V7a2 2 0 00-2-2H5a2 2 0 00-2 2v12a2 2 0 002 2z"
            />
          </svg>
          <span
            class="font-medium ml-2"
          >
            {{ lastStatus.date | formatDate }}
          </span>
        </div>
        <div class="w-full flex flex-row justify-start items-center relative">
          <div class="w-2.5 h-2.5 rounded-full relative -top-px bg-blue-organization" />
          <div class="ml-2.5 text-lg font-medium text-blue-organization">
            {{ lastStatus.title }}
          </div>
        </div>
        <div class="mt-2.5">
          {{ lastStatus.body }}
        </div>
      </div>
    </div>

    <!-- Ticket concluído -->
    <div
      id="ticket-footer-done"
      v-if="lastStatus.status === 'done'"
      class="w-full relative pl-10 sm:pl-16 pb-4"
    >

      <div
        id="status-icon-done"
        class="absolute -left-7.2 -top-3 p-2.5 text-center align-middle rounded-full bg-white"
      >
        <svg
          xmlns="http://www.w3.org/2000/svg"
          class="h-10 w-10 rounded-full p-1/2 text-center align-middle text-white bg-green-organization"
          viewBox="0 0 20 20"
          fill="currentColor"
        >
          <path
            fill-rule="evenodd"
            d="M10 18a8 8 0 100-16 8 8 0 000 16zm3.707-9.293a1 1 0 00-1.414-1.414L9 10.586 7.707 9.293a1 1 0 00-1.414 1.414l2 2a1 1 0 001.414 0l4-4z"
            clip-rule="evenodd"
          />
        </svg>
      </div>

      <div
        id="ticket-footer-body-done"
        class="w-full flex flex-col justify-start items-start text-gray-800"
      >
        <div class="w-full flex flex-row  justify-start items-center">
          <svg
            xmlns="http://www.w3.org/2000/svg"
            class="h-4 w-4 text-gray-500 -ml-px relative -top-px"
            fill="none"
            viewBox="0 0 24 24"
            stroke="currentColor"
          >
            <path
              stroke-linecap="round"
              stroke-linejoin="round"
              stroke-width="2"
              d="M8 7V3m8 4V3m-9 8h10M5 21h14a2 2 0 002-2V7a2 2 0 00-2-2H5a2 2 0 00-2 2v12a2 2 0 002 2z"
            />
          </svg>
          <span
            class="font-medium ml-2"
          >
            {{ lastStatus.date | formatDate }}
          </span>
        </div>
        <div class="w-full flex flex-row justify-start items-center relative">
          <div class="w-2.5 h-2.5 rounded-full relative -top-px bg-green-organization" />
          <div class="ml-2.5 text-lg font-medium text-green-organization">
            {{ lastStatus.title }}
          </div>
        </div>
        <div class="mt-2.5">
          {{ lastStatus.body }}
        </div>
      </div>
    </div>

    <!-- Ticket cancelado -->
    <div
      id="ticket-footer-canceled"
      v-if="lastStatus.status === 'canceled'"
      class="w-full relative pl-10 sm:pl-16 pb-4"
    >

      <div
        id="status-icon-canceled"
        class="absolute -left-7.2 -top-3 p-2.5 text-center align-middle rounded-full bg-white"
      >
        <svg
          xmlns="http://www.w3.org/2000/svg"
          class="h-10 w-10 rounded-full p-1/2 text-center align-middle text-white bg-gray-500"
          viewBox="0 0 20 20"
          fill="currentColor"
        >
          <path
            fill-rule="evenodd"
            d="M10 18a8 8 0 100-16 8 8 0 000 16zM8.707 7.293a1 1 0 00-1.414 1.414L8.586 10l-1.293 1.293a1 1 0 101.414 1.414L10 11.414l1.293 1.293a1 1 0 001.414-1.414L11.414 10l1.293-1.293a1 1 0 00-1.414-1.414L10 8.586 8.707 7.293z"
            clip-rule="evenodd"
          />
        </svg>
      </div>

      <div
        id="ticket-footer-body-canceled"
        class="w-full flex flex-col justify-start items-start text-gray-800"
      >
        <div class="w-full flex flex-row  justify-start items-center">
          <svg
            xmlns="http://www.w3.org/2000/svg"
            class="h-4 w-4 text-gray-500 -ml-px relative -top-px"
            fill="none"
            viewBox="0 0 24 24"
            stroke="currentColor"
          >
            <path
              stroke-linecap="round"
              stroke-linejoin="round"
              stroke-width="2"
              d="M8 7V3m8 4V3m-9 8h10M5 21h14a2 2 0 002-2V7a2 2 0 00-2-2H5a2 2 0 00-2 2v12a2 2 0 002 2z"
            />
          </svg>
          <span
            class="font-medium ml-2"
          >
            {{ lastStatus.date | formatDate }}
          </span>
        </div>
        <div class="w-full flex flex-row justify-start items-center relative">
          <div class="w-2.5 h-2.5 rounded-full relative -top-px bg-gray-organization" />
          <div class="ml-2.5 text-lg font-medium text-gray-organization">
            {{ lastStatus.title }}
          </div>
        </div>
        <div class="mt-2.5">
          {{ lastStatus.body }}
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import dayjs from 'dayjs'
import 'dayjs/locale/pt-br'

export default {
  name: 'ExternalTicketUpdateItemFooter',

  filters: {
    formatDate: value => (!value ? null : dayjs(value).format('DD/MM/YYYY - HH:mm'))
  },

  props: {
    lastStatus: Object
  }
}
</script>
